import React, {useState} from 'react';

import styles from './AmountCounter.module.css'
import {minusBtnIcon, minusOrangeBtnIcon, plusBtnIcon, plusGreyBtnIcon} from "../../../../../../assets/icons/icons.ts";
import {cn} from "../../../../../../utils/cn.ts";
import { formatToLocaleString } from '../../../../../../utils/formatters/formatToLocaleString.ts';

interface Props {
    price: number,
    amount: number,
    stock: number,
    add: () => void
    remove: () => void
    counterTotalCss?: string
}

export const AmountCounter: React.FC<Props> = ({price, amount, add, stock, remove, counterTotalCss}) => {
    const [amountValue, setAmountValue] = useState(amount);
    const changeAmount = (action: string) => {
        if(action === 'remove' && amountValue > 1) {
            remove();
            let newAmountValue = amountValue;
            newAmountValue--;
            setAmountValue(newAmountValue);
        }
        if(amountValue < stock && action === 'add') {
            add();
            let newAmountValue = amountValue;
            newAmountValue++;
            setAmountValue(newAmountValue);
        }
    }

    return (<>
            <div className={styles.amountWrapper}>
                <img
                    src={amountValue === 1 ? minusBtnIcon : minusOrangeBtnIcon}
                    width={17}
                    height={17}
                    alt='Убрать товар'
                    onClick={() => changeAmount('remove')}
                />
                <div className={styles.amount}>
                    {amountValue}
                </div>
                <img
                    src={amountValue < stock ? plusBtnIcon : plusGreyBtnIcon}
                    width={17}
                    height={17}
                    alt='Добавить товар'
                    onClick={() => changeAmount('add')}
                />
            </div>
            <div className={cn(counterTotalCss)}>
                {price && amountValue &&
                    <div
                        className={styles.totalPrice}>{formatToLocaleString(String(price * amountValue))} ₽
                    </div>}
            </div>
    </>);
};